import './depoimentos.css';
import DepoCard from '../DepoCard/DepoCard';
import { AnimationOnScroll } from 'react-animation-on-scroll';

import { depoNome1, depoNome2, depoNome3, depoNome4 } from './depoimentoNome';
import { depoTexto1, depoTexto2, depoTexto3, depoTexto4 } from './depoimentoTexto';
import { Google5 } from '../DepoCard/depoImg';
import pt from "../../locales/pt.json"

const Depoimentos = () => {
  return (
    <div className="psico__depoimentos">
      <AnimationOnScroll animateIn="slide-in-left" duration={1.5}>
        <p>{pt.depoimentos.title}</p>
        <h1>{pt.depoimentos.subtitle}</h1>
      </AnimationOnScroll>
      
      <AnimationOnScroll animateIn="slide-in-left" duration={1.5}>
        <div className='psico__depoimentos-row1'>
          <DepoCard iniciais={depoNome1} texto={depoTexto1} />
          <DepoCard iniciais={depoNome2} texto={depoTexto2} />
        </div>
      </AnimationOnScroll>

      <AnimationOnScroll animateIn="slide-in-right" duration={1.5}>
        <div className='psico__depoimentos-row2'>
          <DepoCard iniciais={depoNome3} texto={depoTexto3} />
          <DepoCard iniciais={depoNome4} texto={depoTexto4} />
        </div>
      </AnimationOnScroll>
      
      <AnimationOnScroll animateIn="fade-in-bottom" duration={1.5}>
        <div className='psico__depoimentos-button'>
          <h4>
            {pt.depoimentos.mais}
          </h4>
          <p>{pt.depoimentos.estrelas}</p>

          <div className="psico__sobre-content__about-text__top5">
            <div className="b_container">
              <a target="_blank" rel="noreferrer" href="https://www.google.com/search?q=Psic%C3%B3logo+Andr%C3%A9+Parreira">
                <img src={Google5} alt="Avaliação 5 estrelas no Google." />
              </a>
            </div>
            <div className="img_container">
              <p></p>
            </div>
          </div>
        </div>
      </AnimationOnScroll>

      {/* <div className="psico__sobre-content__about-text__top5Mobile">
        <div className="b_containerMobile">
          <a target="_blank" rel="noreferrer" href="https://www.google.com/search?q=Psic%C3%B3logo+Andr%C3%A9+Parreira">
            <img src={Google5} alt="Avaliação 5 estrelas no Google." />
          </a>
        </div>
      </div> */}
    </div>
  )
}

export default Depoimentos
